module.exports = __webpack_public_path__ + "img/P150T_weapon_31.7815635e.png";